(function () {
  'use strict';

  /* @ngdoc object
   * @name informacio.people
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat.informacio.people', []);
}());
